// Register it globally
import Vue from 'vue'
// Install Vee Validation v3.3.7

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/ja.json';
import moment from 'moment';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

extend('requird_insured', {
  params: ['careInsuredCheck'],
  validate(value, { careInsuredCheck }) {
    if (value === true || careInsuredCheck === true) {
      return true;
    }
    return false;
  },
  message: '健康保険証か介護保険証どちらか添付（チェック）してください'
});
extend('requird_careInsured', {
  params: ['insuredCheck'],
  validate(value, { insuredCheck }) {
    if (value === true || insuredCheck === true) {
      return true;
    }
    return false;
  },
  message: '健康保険証か介護保険証どちらか添付（チェック）してください'
});

extend('date_format', (value) => {
  if (moment(value, "YYYYMMDD").isValid()) {
    return true;
  }
  return '生年月日を正しく入力してください'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

export default {
  name: 'validate',
}

